export default {
  title: 'KIOSK APP SETTINGS',
  items: {
    KioskRideRequestTimeout: {
      label: 'Ride Request Timeout',
      type: 'integer',
      unit: 'seconds'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/kiosk-app-settings.js